const _ = require("lodash");

const isSame = (x, y) => x === y || (_.isNaN(x) && _.isNaN(y));

const getIn = function(obj, keyList, defaultValue) {
	if (!Array.isArray(keyList)) {
		keyList = String(keyList).split(".");
	}
	let value = obj;
	keyList.forEach(key => (value = value ? value[key] : undefined));
	return value === undefined ? defaultValue : value;
};

// Helper for setIn. keyList must be an array.
const setInLevel = function(currValue, keyList, f, index) {
	const key = keyList[index];
	if (index >= keyList.length) {
		return f(currValue);
	}
	currValue = currValue === undefined ? {} : currValue;
	if (typeof currValue !== "object" || currValue === null) {
		throw new Error(
			"Key path " +
				keyList.join(".") +
				" led to " +
				"a non-object " +
				currValue +
				" at index " +
				index +
				"."
		);
	}
	const newValueAtKey = setInLevel(currValue[key], keyList, f, index + 1);
	if (isSame(newValueAtKey, currValue[key])) {
		return currValue;
	}
	const newValue = currValue ? _.clone(currValue) : {};
	if (Array.isArray(currValue)) {
		newValue.splice(key, 1, newValueAtKey);
	} else {
		newValue[key] = newValueAtKey;
	}
	return newValue;
};

// Immutability helper. Provide an object to update, an array of keys, and
// either a new value or a function taking the old value and returning the new
// one. Returns the original object with the updated value. As an alternative
// to the array of keys, you can pass a period separated string.
const setIn = function(obj, keyList, value) {
	if (!Array.isArray(keyList)) {
		keyList = String(keyList).split(".");
	}
	const f = typeof value === "function" ? value : () => value;
	return setInLevel(obj, keyList, f, 0);
};

// Immutability helper. valuesToSet is an object mapping keys to values to add
// or replace. The original object is not cloned if all values are the same.
// Unlike setIn, valuesToSet cannot be a function.
const extendIn = function(obj, keyList, valuesToSet) {
	return setIn(obj, keyList, oldValue => {
		let mutating = false;
		let newValue = oldValue || {};
		_.each(valuesToSet, (value, key) => {
			if (mutating) {
				newValue[key] = value;
			} else if (!isSame(newValue[key], value)) {
				mutating = true;
				newValue = _.clone(newValue);
				newValue[key] = value;
			}
		});
		return newValue;
	});
};

module.exports = {
	getIn,
	setIn,
	extendIn,
};
